<template>
  <div class="tenant-management">
    <el-card class="search-card">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="租户名称">
          <el-input
            v-model="searchForm.tenantName"
            placeholder="请输入租户名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="租户编码">
          <el-input
            v-model="searchForm.tenantCode"
            placeholder="请输入租户编码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
            <el-option label="启用" :value="0"></el-option>
            <el-option label="禁用" :value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
          <el-button type="primary" @click="handleAdd">新增租户</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="table-card">
      <el-table
        v-loading="loading"
        :data="tenantList"
        border
        fit
        highlight-current-row
      >
        <el-table-column
          label="序号"
          type="index"
          width="60"
          align="center"
        />
        <el-table-column
          label="租户ID"
          prop="id"
          width="80"
          align="center"
        />
        <el-table-column
          label="租户名称"
          prop="tenantName"
          min-width="150"
          align="center"
        />
        <el-table-column
          label="租户编码"
          prop="tenantCode"
          width="120"
          align="center"
        />
        <el-table-column
          label="联系人"
          prop="contactName"
          width="100"
          align="center"
        />
        <el-table-column
          label="联系电话"
          prop="contactPhone"
          width="130"
          align="center"
        />
        <el-table-column
          label="有效期至"
          prop="expireTime"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.expireTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column
          label="状态"
          prop="status"
          width="80"
          align="center"
        >
          <template slot-scope="scope">
            <el-tag :type="scope.row.status === 0 ? 'success' : 'danger'">
              {{ scope.row.status === 0 ? '启用' : '禁用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          prop="createTime"
          width="180"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.createTime | formatDate }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="200"
        >
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="handleEdit(scope.row)"
            >编辑</el-button>
            <el-button
              type="text"
              size="small"
              @click="handleToggleStatus(scope.row)"
            >{{ scope.row.status === 0 ? '禁用' : '启用' }}</el-button>
            <el-button
              type="text"
              size="small"
              style="color: #F56C6C"
              @click="handleDelete(scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageDto.current"
        :limit.sync="queryParams.pageDto.size"
        @pagination="getList"
      />
    </el-card>

    <!-- 新增/编辑租户弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="tenantForm"
        :model="tenantForm"
        :rules="tenantRules"
        label-width="100px"
      >
        <el-form-item label="租户名称" prop="tenantName">
          <el-input
            v-model="tenantForm.tenantName"
            placeholder="请输入租户名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="租户编码" prop="tenantCode">
          <el-input
            v-model="tenantForm.tenantCode"
            placeholder="请输入租户编码"
            :disabled="isEdit"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="contactName">
          <el-input
            v-model="tenantForm.contactName"
            placeholder="请输入联系人"
          ></el-input>
        </el-form-item>
        <el-form-item label="联系电话" prop="contactPhone">
          <el-input
            v-model="tenantForm.contactPhone"
            placeholder="请输入联系电话"
          ></el-input>
        </el-form-item>
        <el-form-item label="有效期至" prop="expireTime">
          <el-date-picker
            v-model="tenantForm.expireTime"
            type="datetime"
            placeholder="请选择有效期"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="tenantForm.status">
            <el-radio :label="0">启用</el-radio>
            <el-radio :label="1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model="tenantForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TenantApi from '@/api/tenant'
import Pagination from '@/components/PaginationStyle1'

export default {
  name: 'TenantManagement',
  components: { Pagination },
  data() {
    return {
      loading: false,
      tenantList: [],
      total: 0,
      searchForm: {
        tenantName: '',
        tenantCode: '',
        status: null
      },
      queryParams: {
        tenantName: '',
        tenantCode: '',
        status: null,
        pageDto: {
          current: 1,
          size: 10
        }
      },
      dialogVisible: false,
      dialogTitle: '新增租户',
      isEdit: false,
      tenantForm: {
        id: null,
        tenantName: '',
        tenantCode: '',
        contactName: '',
        contactPhone: '',
        expireTime: '',
        status: 0,
        remark: ''
      },
      tenantRules: {
        tenantName: [
          { required: true, message: '请输入租户名称', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
        ],
        tenantCode: [
          { required: true, message: '请输入租户编码', trigger: 'blur' },
          { min: 2, max: 32, message: '长度在 2 到 32 个字符', trigger: 'blur' },
          { pattern: /^[a-zA-Z0-9_-]+$/, message: '只能包含字母、数字、下划线和横线', trigger: 'blur' }
        ],
        contactName: [
          { max: 50, message: '长度不能超过 50 个字符', trigger: 'blur' }
        ],
        contactPhone: [
          { max: 20, message: '长度不能超过 20 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
    formatDate(date) {
      if (!date) return '-'
      return date
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    async getList() {
      this.loading = true
      // 模拟数据 - 用于界面展示
      setTimeout(() => {
        this.tenantList = [
          {
            id: 1,
            tenantName: '测试租户A',
            tenantCode: 'tenant_a',
            contactName: '张三',
            contactPhone: '13800138001',
            expireTime: '2026-12-31 23:59:59',
            status: 0,
            createTime: '2025-01-15 10:30:00',
            remark: '这是一个测试租户'
          },
          {
            id: 2,
            tenantName: '测试租户B',
            tenantCode: 'tenant_b',
            contactName: '李四',
            contactPhone: '13800138002',
            expireTime: '2025-06-30 23:59:59',
            status: 1,
            createTime: '2025-02-20 14:20:00',
            remark: ''
          },
          {
            id: 3,
            tenantName: '某某市政公司',
            tenantCode: 'szgs_001',
            contactName: '王五',
            contactPhone: '13900139001',
            expireTime: '2027-03-31 23:59:59',
            status: 0,
            createTime: '2025-03-01 09:00:00',
            remark: '市政管网管理'
          }
        ]
        this.total = 3
        this.loading = false
      }, 500)
      // 后端接口（暂时注释）
      // try {
      //   const res = await TenantApi.queryTenantList(this.queryParams)
      //   if (res.data.code === 200) {
      //     this.tenantList = res.data.data.records || []
      //     this.total = res.data.data.total || 0
      //   } else {
      //     this.$message.error(res.data.msg || '获取租户列表失败')
      //   }
      // } catch (error) {
      //   console.error('获取租户列表失败:', error)
      //   this.$message.error('获取租户列表失败')
      // } finally {
      //   this.loading = false
      // }
    },
    handleSearch() {
      this.queryParams.tenantName = this.searchForm.tenantName
      this.queryParams.tenantCode = this.searchForm.tenantCode
      this.queryParams.status = this.searchForm.status
      this.queryParams.pageDto.current = 1
      this.getList()
    },
    handleReset() {
      this.searchForm = {
        tenantName: '',
        tenantCode: '',
        status: null
      }
      this.handleSearch()
    },
    handleAdd() {
      this.isEdit = false
      this.dialogTitle = '新增租户'
      this.resetForm()
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.isEdit = true
      this.dialogTitle = '编辑租户'
      this.tenantForm = {
        id: row.id,
        tenantName: row.tenantName,
        tenantCode: row.tenantCode,
        contactName: row.contactName,
        contactPhone: row.contactPhone,
        expireTime: row.expireTime,
        status: row.status,
        remark: row.remark
      }
      this.dialogVisible = true
    },
    submitForm() {
      this.$refs.tenantForm.validate(async (valid) => {
        if (valid) {
          // 模拟操作 - 用于界面展示
          this.$message.success(this.isEdit ? '修改成功（模拟）' : '新增成功（模拟）')
          this.dialogVisible = false
          this.getList()
          // 后端接口（暂时注释）
          // try {
          //   const api = this.isEdit ? TenantApi.updateTenant : TenantApi.addTenant
          //   const res = await api(this.tenantForm)
          //   if (res.data.code === 200) {
          //     this.$message.success(this.isEdit ? '修改成功' : '新增成功')
          //     this.dialogVisible = false
          //     this.getList()
          //   } else {
          //     this.$message.error(res.data.msg || '操作失败')
          //   }
          // } catch (error) {
          //   console.error('操作失败:', error)
          //   this.$message.error('操作失败')
          // }
        }
      })
    },
    resetForm() {
      this.tenantForm = {
        id: null,
        tenantName: '',
        tenantCode: '',
        contactName: '',
        contactPhone: '',
        expireTime: '',
        status: 0,
        remark: ''
      }
      if (this.$refs.tenantForm) {
        this.$refs.tenantForm.resetFields()
      }
    },
    async handleToggleStatus(row) {
      const newStatus = row.status === 0 ? 1 : 0
      const statusText = newStatus === 0 ? '启用' : '禁用'
      try {
        await this.$confirm(`确定要${statusText}该租户吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        // 模拟操作 - 用于界面展示
        this.$message.success(`${statusText}成功（模拟）`)
        row.status = newStatus
        // 后端接口（暂时注释）
        // const res = await TenantApi.updateTenantStatus({
        //   id: row.id,
        //   status: newStatus
        // })
        // if (res.data.code === 200) {
        //   this.$message.success(`${statusText}成功`)
        //   this.getList()
        // } else {
        //   this.$message.error(res.data.msg || '操作失败')
        // }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('操作失败:', error)
          this.$message.error('操作失败')
        }
      }
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除该租户吗？删除后不可恢复！', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        // 模拟操作 - 用于界面展示
        this.$message.success('删除成功（模拟）')
        this.tenantList = this.tenantList.filter(item => item.id !== row.id)
        this.total = this.tenantList.length
        // 后端接口（暂时注释）
        // const res = await TenantApi.deleteTenant({ id: row.id })
        // if (res.data.code === 200) {
        //   this.$message.success('删除成功')
        //   this.getList()
        // } else {
        //   this.$message.error(res.data.msg || '删除失败')
        // }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error)
          this.$message.error('删除失败')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.tenant-management {
  padding: 20px;

  .search-card {
    margin-bottom: 20px;
  }

  .table-card {
    .el-table {
      margin-top: 10px;
    }
  }
}
</style>
